<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Setup Master Data</div>
        <!-- <div>
          <bread-crumb :bread-crumbs="['Master Data']" />
        </div> -->
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <v-card-text>
        <v-card-title>
          <v-row class="">
            <!-- -------------------------------modal to add category ------------------- -->
            <v-dialog persistent max-width="400px" v-model="dialog">
              <template v-slot:activator="{ on, attrs }">
                <v-row class="mt-0">
                  <v-col cols="12" md="3">
                    <v-btn
                      depressed
                      color="primary"
                      small
                      @click="editItem()"
                      dark
                      class="me-3 text-capitalize"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-plus-outline</v-icon
                      >Add Category
                    </v-btn>
                    <v-btn
                      depressed
                      @click="downloadExcelsheet"
                      color="primary"
                      small
                      ><v-icon small>mdi-file-excel-outline</v-icon>Export
                    </v-btn>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </template>

              <v-card>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-toolbar dark color="#050048" flat dense>
                    <span class="subtitleFontsize">{{ formtitle }}</span>
                    <v-spacer></v-spacer>
                    <v-btn depressed small icon @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text class="">
                    <v-row>
                      <v-radio-group v-model="selectpamaterType" row>
                        <v-radio label="New parameter" value="new"></v-radio>
                        <v-radio
                          label="Existing parameter"
                          value="exist"
                        ></v-radio>
                      </v-radio-group>
                      <v-col
                        cols="12"
                        md="12"
                        v-if="selectpamaterType === 'exist'"
                      >
                        <label class="my-0 rounded labelFontsize required"
                          >Existing Parameter
                        </label>
                        <v-autocomplete
                          class="rounded"
                          dense
                          v-model="parameterdetails.parent_parameter_id"
                          :items="parametersdropList"
                          item-text="text"
                          item-value="value"
                          :rules="existingParam"
                          outlined
                          placeholder="Select Existing Parameter"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="12">
                        <label class="my-0 rounded labelFontsize required">
                          Name
                        </label>

                        <v-text-field
                          dense
                          outlined
                          placeholder="Name"
                          v-model="parameterdetails.parameter_name"
                          :rules="Name"
                          class="rounded"
                          @input="validateparameterName()"
                        >
                        </v-text-field>
                        <span
                          v-if="parameterdetails.parameter_name"
                          v-bind:style="{
                            color: isnameavalaible.success
                              ? 'green !important'
                              : ' red !important',
                          }"
                          class="caption"
                        >
                          {{ isnameavalaible.message }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row class="">
                      <v-col cols="12" md="12">
                        <label class="my-0 rounded labelFontsize required">
                          Parameter Code
                        </label>
                        <v-text-field
                          placeholder="Parameter Code"
                          dense
                          outlined
                          v-model="parameterdetails.parameter_code"
                          :rules="parametercode"
                          class="rounded"
                          @input="validateparameterCode()"
                        ></v-text-field>

                        <span
                          v-if="parameterdetails.parameter_code"
                          :style="{
                            color: isavalaible.success
                              ? 'green !important'
                              : ' red !important',
                          }"
                          class="caption"
                        >
                          {{ isavalaible.message }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row class="">
                      <v-col cols="12" md="12">
                        <label class="my-0 rounded labelFontsize required">
                          Description
                        </label>
                        <v-text-field
                          placeholder="Description"
                          dense
                          outlined
                          v-model="parameterdetails.description"
                          :rules="descrption"
                          class="rounded"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider class="ma-0 pa-0"> </v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      depressed
                      small
                      color="primary"
                      @click="onclickNext()"
                      v-if="!parameterdetails.id"
                      class="text-capitalize"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-plus-outline</v-icon
                      >Add
                    </v-btn>

                    <v-btn
                      depressed
                      small
                      color="primary"
                      @click="onClickBack({})"
                      v-if="!parameterdetails.id"
                      class="text-capitalize"
                      outlined
                    >
                      <v-icon small class="me-2"
                        >mdi-close-circle-outline</v-icon
                      >
                      Cancel
                    </v-btn>
                    <v-btn
                      depressed
                      small
                      color="primary"
                      class="text-capitalize"
                      @click="update()"
                      v-if="parameterdetails.id"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-edit-outline</v-icon
                      >
                      Update
                    </v-btn>
                    <v-btn
                      depressed
                      small
                      color="primary"
                      class="text-capitalize ms-2"
                      @click="onClickBack()"
                      outlined
                      v-if="parameterdetails.id"
                    >
                      <v-icon small class="me-2"
                        >mdi-close-circle-outline</v-icon
                      >
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <!-- -------------------------------modal to add category ------------------- -->

            <!-- ------------------------------- to delete the record ------------------- -->
            <v-dialog v-model="dialogDelete" width="500">
              <v-card>
                <v-card-title class="border border-bottom">Delete</v-card-title>
                <v-card-text class="h5 py-3"
                  >Are you sure you want to delete this prameter?</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    small
                    color="primary"
                    outlined
                    @click="deleteItemConfirm"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                  <v-btn
                    depressed
                    small
                    color="primary"
                    outlined
                    @click="closeDelete"
                    ><v-icon>mdi-close</v-icon></v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </v-card-title>
        <!-- -----------------------category table Master Data------------------------- -->

        <recursive-table
          :parametersList="parametersList"
          @editItemData="editItemData"
        ></recursive-table>
        <loading :active="loader" :opacity="0.9" color="#ff6b00" />
      </v-card-text>
    </v-card>
  </section>
</template>
<script>
import alerts from "@/mixins/alerts";
import { Masterdata } from "@/utils/validationCopy.js";
import Loading from "vue-loading-overlay";
// import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import setupService from "@/services/SetupService/setupService.js";
import RecursiveTable from "./RecursiveTable.vue";
export default {
  mixins: [alerts],
  name: "Master Data",
  data() {
    return {
      ...Masterdata,
      item: ["Active", "In-Active"],
      selectpamaterType: "new",
      parametersList: [],
      parametersdropList: [],
      dialogDelete: false,
      dialog: false,
      valid: true,
      isLoading: false,
      loader: false,
      search: "",
      selectedOption: "new",

      editedIndex: -1,

      parameterdetails: {
        parameter_name: "",
        parameter_code: "",
        description: "",
        parent_parameter_id: null,
      },
      defaultItem: {
        parameter_name: "",
        parameter_code: "",
        description: "",
      },

      isavalaible: {},
      isnameavalaible: {},
      deleteId: "",
      is_active: "",
      expanded: [],
    };
  },

  components: {
    // BreadCrumb,
    RecursiveTable,
    Loading,
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add Category" : "Edit Category";
    },
  },

  mounted() {
    this.getallparameters();
    this.getExistingParameters();
  },

  watch: {
    dialog(val) {
      val || this.onClickBack();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    async downloadExcelsheet() {
      if (this.parametersList) {
        this.exportToExcel(
          this.headers,
          this.parametersList,
          "parameters_List"
        );
      }
    },
    pinNewValues(item) {
      console.log(item);
      this.$router.push("partnerMasterdata");
    },

    async getallparameters() {
      this.isLoading = true;
      try {
        const responseData = await setupService.getParameters();
        this.isLoading = false;
        if (responseData.data.status_code === 200) {
          this.parametersList = responseData.data.data.reverse();
        }

        console.log("getallparameters", this.parametersList);
      } catch (e) {
        this.isLoading = false;
        console.error(e);
      }
    },
    async getExistingParameters() {
      try {
        const responseData = await setupService.getExistingParameters();
        if (responseData.data.status_code === 200) {
          this.parametersdropList = responseData.data.data.map((ele) => {
            return {
              value: ele.id,
              text: ele.parameter_name,
            };
          });
        }
        console.log("respose data", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    hasMatchingMain(obj) {
      // Check if there are other objects with the same main value and a non-null id
      return this.parametersList.some(
        (item) =>
          item.id === obj.parent_parameter_id &&
          item.parent_parameter_id !== null
      );
    },
    async validateparameterCode() {
      try {
        const responseData = await setupService.getValidateParameterCode(
          this.parameterdetails.parameter_code
        );
        if (responseData.data.status_code === 200) {
          this.isavalaible = responseData.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.validateparameterCode();
        // }
        else if (responseData.data.status_code === 409) {
          this.isavalaible = responseData.data;
        }
        console.log("validateparameterCode", responseData);
      } catch (e) {
        console.log("ss " + e);
        this.isavalaible = {
          message: "Something went wrong",
          data: [],
          status_code: 409,
          success: false,
        };
      }
    },
    async validateparameterName() {
      try {
        const responseData = await setupService.getValidateParameterName(
          this.parameterdetails.parameter_name
        );
        if (responseData.data.status_code === 200) {
          this.isnameavalaible = responseData.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.validateparameterName();
        // }
        else if (responseData.data.status_code === 409) {
          this.isnameavalaible = responseData.data;
        }
        console.log("validateparameterName", responseData);
      } catch (e) {
        console.log("ss " + e);
        this.isnameavalaible = {
          message: "Something went wrong",
          data: [],
          status_code: 409,
          success: false,
        };
      }
    },

    onclickNext() {
      console.log(`prametervalues: ${JSON.stringify(this.parameterdetails)}`);

      this.postList();
    },

    onClickBack() {
      this.dialog = false;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.isavalaible = {};

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 200);
    },

    async postList() {
      const validate = this.$refs.form.validate();
      if (validate & this.isavalaible.success & this.isnameavalaible.success) {
        this.loader = true;
        if (this.editedIndex > -1) {
          Object.assign(
            this.parametersList[this.editedIndex],
            this.parameterdetails
          );
        } else {
          try {
            const responseData = await setupService.addParameterDetails(
              this.parameterdetails
            );
            console.log(`responseData: ${JSON.stringify(responseData)}`);
            if (responseData && responseData.data.status_code == 200) {
              this.showAlertSuccess(responseData.data.message);
              this.getallparameters();
              setTimeout(() => {
                this.loader = false;
              }, 400);
            }
            // else if (responseData.data.status_code === 401) {
            //   this.returnNewToken();
            //   this.postList();
            // }
            else {
              this.showAlertError(responseData.data.message);
              this.loader = false;
            }
            console.log("respose data", responseData);
          } catch (error) {
            console.log(error);
            this.showAlertError("Something went wrong please try again later.");
            this.loader = false;
          }
        }
        this.onClickBack();
      }
    },

    async isactiveupdate(isactive) {
      console.log(isactive, "u");
      this.loader = true;
      if (this.editedIndex < -1) {
        Object.assign(
          this.parametersList[this.editedIndex],
          this.parameterdetails
        );
      } else {
        console.log("parameterdetails ", JSON.stringify(this.parameterdetails));
        try {
          const responseData = await setupService.activeUpdateParameterDetails(
            isactive.id,
            isactive.is_active
          );
          console.log(`responseData: ${JSON.stringify(responseData)}`);
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess("Status is Updated", "success");
            this.getallparameters();
          }
          // else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.isactiveupdate(isactive);
          // }
          console.log("respose data", responseData);
        } catch (error) {
          console.log(error);
          this.showAlertError("Something went wrong please try again later.");
        }
        setTimeout(() => {
          this.loader = false;
        }, 400);
      }

      this.onClickBack();
    },
    editItem(item) {
      console.log("item", item);
      this.dialog = true;

      this.editedIndex = this.parametersList.indexOf(item);
      this.parameterdetails = Object.assign({}, item);
      console.log("parameterdetails", this.parameterdetails);
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    editItemData(item) {
      this.editItem(item);
    },
    onupdate() {
      this.update();
    },

    async update() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loader = true;
        if (this.editedIndex < -1) {
          Object.assign(
            this.parametersList[this.editedIndex],
            this.parameterdetails
          );
        } else {
          console.log(
            "parameterdetails ",
            JSON.stringify(this.parameterdetails)
          );
          try {
            const responseData = await setupService.updateParameterDetails(
              this.parameterdetails.id,
              this.parameterdetails
            );
            console.log(`responseData: ${JSON.stringify(responseData)}`);
            if (responseData && responseData.data.status_code == 200) {
              this.showAlertSuccess(responseData.data.message);
              this.getallparameters();
              setTimeout(() => {
                this.loader = false;
              }, 400);
            } else {
              this.showAlertError(responseData.data.message);
              this.loader = false;
            }
            console.log("respose data", responseData);
          } catch (error) {
            console.log(error);
            this.showAlertError("Something went wrong please try again later.");
            this.loader = false;
          }
        }

        this.onClickBack();
      }
    },

    deleteItem(item) {
      this.dialogDelete = true;
      this.deleteId = item.id;
    },

    async deleteItemConfirm() {
      this.loader = true;
      try {
        const responseData = await setupService.deleteParameterDetails(
          this.deleteId
        );
        setTimeout(() => {
          this.loader = false;
        }, 400);
        this.response = responseData;
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getallparameters();
        } else {
          this.showAlertError(responseData.data.message);
          this.loader = false;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.deleteItemConfirm();
        // }
      } catch (error) {
        console.log(error.response);
        this.showAlertError("Something went wrong please try again later.");
      }
      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.parameterdetails = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.deleteId = "";
      });
    },
    nextpage(item) {
      console.log("item " + item);
      this.$router.push({
        name: "Master Data Value",
        query: {
          code: item.parameter_code,
          name: item.parameter_name,
          id: item.id,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
  margin-bottom: 0px;
  margin-right: 30px;
}
::v-deep .v-input--radio-group--column .v-input--radio-group__input {
  flex-direction: row;
}
</style>
